exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".h-stack[data-v-4968875a]{padding:var(--h-stack-padY) var(--h-stack-padX)}.h-stack>*[data-v-4968875a]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;margin:calc(var(--h-stack-gap)/2*-1)}.h-stack>*>*[data-v-4968875a]{-ms-flex-preferred-size:calc((var(--measure) - 100% - var(--h-stack-gap))*999);flex-basis:calc((var(--measure) - 100% - var(--h-stack-gap))*999);-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;margin:calc(var(--h-stack-gap)/2)}.h-stack>*[data-v-4968875a]>:nth-last-child(n+5),.h-stack>*>:nth-last-child(n+5)~*[data-v-4968875a]{-ms-flex-preferred-size:100%;flex-basis:100%}", ""]);

// exports
